import { Input, Collapse } from 'antd';
import { useEffect, useState } from 'react';
import companyService from '../services/company.service';
import { useTheme } from 'styled-components';

const { Panel } = Collapse;
const FAQView = ({ user }) => {
	const [data, setData] = useState([]);
	const [filterdList, setFilterdList] = useState<any>([]);
	const theme = useTheme();
	useEffect(() => {
		fetchData();
	}, []);

	let fetchData = async () => {
		let response = await companyService.getFaqQuestions();
		setData(response?.success);
		setFilterdList(response?.success);
	};

	let handel = e => {
		let updatedList = data.filter(({ question, answer }: any) => {
			return (
				question.toLowerCase().search(e.target.value.toLowerCase()) !== -1 ||
				answer.toLowerCase().search(e.target.value.toLowerCase()) !== -1
			);
		});
		setFilterdList(updatedList);
	};

	return (
		<div className={user ? '' : 'bg-overlay-dark'}>
			<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
				<div className="m-4 text-center">
					<p
						style={{
							color: theme.TA_GREEN,
							fontSize: '2.625rem',
							fontWeight: 400,
							margin: '10px 0'
						}}
						className="text-start"
					>
						{(() => {
							if (user) {
								return <div>Hi {user?.firstName},</div>;
							}
						})()}
						How can we help you?
					</p>
					<Input className="w-100 rounded" size="large" placeholder="How to ..." onChange={handel} />
				</div>
				{filterdList?.length !== 0 && (
					<div className="p-0 mt-0 my-md-4 ta-form-container d-flex justify-content-center">
						<Collapse accordion className="w-100">
							{filterdList?.map(row => (
								<Panel header={row.question} key={row.key}>
									<p>{row.answer}</p>
								</Panel>
							))}
						</Collapse>
					</div>
				)}
			</div>
		</div>
	);
};

export default FAQView;
